import React from 'react'
import Modal from 'react-modal';

Modal.setAppElement('#root');
const ModalConfirmCustom = (props) => {

    const { show, onClose, onConfirm } = props

    return (
        <Modal
            isOpen={show}
            contentLabel=""
            className="modal-content modal-sm"
            overlayClassName="modal-overlay"
            onRequestClose={onClose}>
            <div className="p-2" style={{ minWidth: '300px' }}>
                {props.children}

                <div className="d-flex flex-row-reverse">
                    <button onClick={onConfirm} type="submit" className="btn btn-sm btn-success mr-1 ml-1" style={{ width: 40 }}>Si</button>
                    <button onClick={onClose} className="btn btn-sm btn-secondary mr-1 ml-1" style={{ width: 40 }}>No</button>
                </div>

            </div>
        </Modal>
    );
}

export default ModalConfirmCustom;